import { store } from '@/common/root';

const fetchRouterName = async (routerId: ID): Promise<string> => {
  const router = await store.$takeFirst('routers/GET_OR_LOAD', { id: routerId });
  return router.name;
};

export default fetchRouterName;
